import { RequestConfig } from '@/interface'

const PRIFX = 'glht/invoice/'
const invoiceConfig: RequestConfig = {
  // 发票预警配置
  adminFpkjConfAddOrUpdate: {
    url: `${PRIFX}fpkjConfAddOrUpdate`,
    method: 'post'
  },
  // 发票预警信息
  adminFpkjConfInfo: {
    url: `${PRIFX}fpkjConfInfo`,
    method: 'post'
  },
  // 授信额度配置
  adminSxedConfAddOrUpdate: {
    url: `${PRIFX}sxedConfAddOrUpdate`,
    method: 'post'
  },
  // 授信额度信息
  admingSxedConfInfo: {
    url: `${PRIFX}sxedConfInfo`,
    method: 'post'
  }
}
export default invoiceConfig
